export default "__VITE_ASSET__D$H4ZM78__"